{
  "patrol_guard": {
    "id": "patrol_guard",
    "name": "PATROL GUARD",
    "HP": 80,
    "maxHp": 80,
    "speed": 4,
    "moveSpeed": 4,
    "detectionRange": 18,
    "attackRange": 14,
    "attackCooldown": 0.833,
    "fireRate": 1.2,
    "attackDamage": 15,
    "projectileDamage": 15,
    "projectileSpeed": 35,
    "projectileType": "bullet",
    "shieldCapacity": 0,
    "hasRiotShield": false,
    "isFlying": false,
    "isTurret": false,
    "color": 9109504,
    "size": [
      0.8,
      1.8,
      0.8
    ],
    "lootTable": [
      {
        "item": "health-tank",
        "weight": 50
      },
      {
        "item": "spread-ammo",
        "weight": 30
      },
      {
        "item": "energy-tank",
        "weight": 20
      }
    ]
  },
  "melee_swarmer": {
    "id": "melee_swarmer",
    "name": "MELEE SWARMER",
    "HP": 45,
    "maxHp": 45,
    "speed": 7,
    "moveSpeed": 7,
    "detectionRange": 20,
    "attackRange": 3,
    "attackCooldown": 0.5,
    "fireRate": 2,
    "attackDamage": 12,
    "projectileDamage": 12,
    "projectileSpeed": 25,
    "projectileType": "melee-strike",
    "shieldCapacity": 0,
    "hasRiotShield": false,
    "isFlying": true,
    "isTurret": false,
    "color": 65535,
    "size": [
      0.8,
      0.4,
      0.8
    ],
    "lootTable": [
      {
        "item": "energy-tank",
        "weight": 60
      },
      {
        "item": "health-tank",
        "weight": 40
      }
    ]
  },
  "heavy_enforcer": {
    "id": "heavy_enforcer",
    "name": "HEAVY ENFORCER",
    "HP": 140,
    "maxHp": 140,
    "speed": 3,
    "moveSpeed": 3,
    "detectionRange": 16,
    "attackRange": 8,
    "attackCooldown": 1,
    "fireRate": 1,
    "attackDamage": 20,
    "projectileDamage": 20,
    "projectileSpeed": 30,
    "projectileType": "heavy-shot",
    "shieldCapacity": 100,
    "hasRiotShield": true,
    "isFlying": false,
    "isTurret": false,
    "color": 2241348,
    "size": [
      1,
      1.9,
      0.9
    ],
    "lootTable": [
      {
        "item": "health-tank",
        "weight": 40
      },
      {
        "item": "missile-ammo",
        "weight": 35
      },
      {
        "item": "reserve-tank",
        "weight": 15
      },
      {
        "item": "keycard-blue",
        "weight": 10
      }
    ]
  },
  "sniper_turret": {
    "id": "sniper_turret",
    "name": "SNIPER TURRET",
    "HP": 120,
    "maxHp": 120,
    "speed": 0,
    "moveSpeed": 0,
    "detectionRange": 28,
    "attackRange": 22,
    "attackCooldown": 0.333,
    "fireRate": 3,
    "attackDamage": 12,
    "projectileDamage": 12,
    "projectileSpeed": 45,
    "projectileType": "sniper-beam",
    "shieldCapacity": 0,
    "hasRiotShield": false,
    "isFlying": false,
    "isTurret": true,
    "color": 16729088,
    "size": [
      0.9,
      0.9,
      0.9
    ],
    "lootTable": [
      {
        "item": "energy-tank",
        "weight": 50
      },
      {
        "item": "cannon-ammo",
        "weight": 30
      },
      {
        "item": "reserve-tank",
        "weight": 20
      }
    ]
  },
  "boss_overlord": {
    "id": "boss_overlord",
    "name": "BOSS OVERLORD",
    "HP": 500,
    "maxHp": 500,
    "speed": 3.5,
    "moveSpeed": 3.5,
    "detectionRange": 32,
    "attackRange": 25,
    "attackCooldown": 0.25,
    "fireRate": 4,
    "attackDamage": 35,
    "projectileDamage": 35,
    "projectileSpeed": 40,
    "projectileType": "plasma-burst",
    "shieldCapacity": 250,
    "hasRiotShield": true,
    "isFlying": false,
    "isTurret": false,
    "color": 8913151,
    "size": [
      2,
      3,
      2
    ],
    "lootTable": [
      {
        "item": "reserve-tank",
        "weight": 40
      },
      {
        "item": "gyrex-ammo",
        "weight": 30
      },
      {
        "item": "keycard-red",
        "weight": 30
      }
    ]
  },
  "scout-drone": {
    "id": "scout-drone",
    "name": "RECON SCOUT DRONE",
    "HP": 50,
    "maxHp": 50,
    "speed": 6.5,
    "moveSpeed": 6.5,
    "detectionRange": 20,
    "attackRange": 16,
    "attackCooldown": 0.5,
    "fireRate": 2,
    "attackDamage": 10,
    "projectileDamage": 10,
    "projectileSpeed": 28,
    "projectileType": "energy",
    "shieldCapacity": 0,
    "hasRiotShield": false,
    "isFlying": true,
    "isTurret": false,
    "color": 65535,
    "size": [
      0.8,
      0.4,
      0.8
    ],
    "lootTable": [
      {
        "item": "energy-tank",
        "weight": 60
      },
      {
        "item": "health-tank",
        "weight": 40
      }
    ]
  },
  "cyborg-trooper": {
    "id": "cyborg-trooper",
    "name": "CYBORG TROOPER",
    "HP": 80,
    "maxHp": 80,
    "speed": 4,
    "moveSpeed": 4,
    "detectionRange": 18,
    "attackRange": 14,
    "attackCooldown": 0.833,
    "fireRate": 1.2,
    "attackDamage": 15,
    "projectileDamage": 15,
    "projectileSpeed": 35,
    "projectileType": "bullet",
    "shieldCapacity": 0,
    "hasRiotShield": false,
    "isFlying": false,
    "isTurret": false,
    "color": 9109504,
    "size": [
      0.8,
      1.8,
      0.8
    ],
    "lootTable": [
      {
        "item": "health-tank",
        "weight": 50
      },
      {
        "item": "spread-ammo",
        "weight": 30
      },
      {
        "item": "energy-tank",
        "weight": 20
      }
    ]
  },
  "riot-trooper": {
    "id": "riot-trooper",
    "name": "RIOT SHIELD ENFORCER",
    "HP": 140,
    "maxHp": 140,
    "speed": 3,
    "moveSpeed": 3,
    "detectionRange": 16,
    "attackRange": 8,
    "attackCooldown": 1,
    "fireRate": 1,
    "attackDamage": 20,
    "projectileDamage": 20,
    "projectileSpeed": 30,
    "projectileType": "shotgun",
    "shieldCapacity": 100,
    "hasRiotShield": true,
    "isFlying": false,
    "isTurret": false,
    "color": 2241348,
    "size": [
      1,
      1.9,
      0.9
    ],
    "lootTable": [
      {
        "item": "health-tank",
        "weight": 40
      },
      {
        "item": "missile-ammo",
        "weight": 35
      },
      {
        "item": "reserve-tank",
        "weight": 15
      },
      {
        "item": "keycard-blue",
        "weight": 10
      }
    ]
  },
  "defense-turret": {
    "id": "defense-turret",
    "name": "AUTOMATED DEFENSE TURRET",
    "HP": 120,
    "maxHp": 120,
    "speed": 0,
    "moveSpeed": 0,
    "detectionRange": 28,
    "attackRange": 20,
    "attackCooldown": 0.333,
    "fireRate": 3,
    "attackDamage": 12,
    "projectileDamage": 12,
    "projectileSpeed": 45,
    "projectileType": "turret-laser",
    "shieldCapacity": 0,
    "hasRiotShield": false,
    "isFlying": false,
    "isTurret": true,
    "color": 16729088,
    "size": [
      0.9,
      0.9,
      0.9
    ],
    "lootTable": [
      {
        "item": "energy-tank",
        "weight": 50
      },
      {
        "item": "cannon-ammo",
        "weight": 30
      },
      {
        "item": "reserve-tank",
        "weight": 20
      }
    ]
  }
}
